import React, { useContext, useState } from 'react';
import { AppContext } from '../main';



const SectionLoc = (props) => {
  const {
    handleEditItem
  } = props

  const { appState
  } = useContext(AppContext);
  const {
    locations = {
      // title: "Server Locations",
      // subtitle: "25 servers worldwide.",
      // locations: [
      //   { name: "United States", top: "39%", left: "20%" },
      //   { name: "Australia", top: "76%", left: "87%" },
      //   { name: "Indonesia", top: "68%", left: "80%" },
      //   { name: "Canada", top: "23%", left: "18%" },
      //   { name: "Brazil", top: "68%", left: "33%" },
      //   { name: "China", top: "45%", left: "75%" },
      //   { name: "France", top: "36%", left: "48%" },
      //   { name: "Sweden", top: "23%", left: "51%" },
      //   { name: "South Africa", top: "78%", left: "53%" },
      // ],
      // marquee: [
      //   { name: "London" }, { name: "Paris" }, { name: "Frankfurt" }, { name: "Amsterdam" }, { name: "Stockholm" }, { name: "Helsinki" },
      //   { name: "Los Angeles" }, { name: "Quebec" }, { name: "Singapore" }, { name: "Sydney" }, { name: "Sao Paulo" }, { name: "Bangkok" }, { name: "Jakarta" }
      // ],
      // mapImage: "./img/misc/world-map.webp",
    }
    , editMode = false
  } = appState

  if (!locations?.locations) {
    return null
  }




  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 offset-lg-3 text-center">
            <div className="subtitle fadeInUp mb-3">{locations.title}</div>
          </div>
          <div className="col-lg-6 offset-lg-3 text-center">
            <h2 className="fadeInUp mb20">{locations.subtitle}</h2>
          </div>
          <div className="spacer-10"></div>
          <div className="col-lg-12 fadeInUp">
            <div className="p-sm-30 pb-sm-0 mb-sm-0">
              <div className="de-map-hotspot">
                {locations.locations.map((location, index) => (
                  <div key={index} className="de-spot fadeIn" style={{ top: location.top, left: location.left }}>
                    <span>{location.name}</span>
                    <div className="de-circle-1"></div>
                    <div className="de-circle-2"></div>
                  </div>
                ))}
                <img src={locations.mapImage} className="img-fluid" alt="Server Locations" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="no-bottom wow fadeInRight d-flex z-1000">
        <div className="de-marquee-list wow">
          <div className="d-item">
            {locations.marquee.map((city, index) => (
              <React.Fragment key={index}>
                <span className="d-item-txt">{city?.name}</span>
                <span className="d-item-display">
                  <i className="d-item-block"></i>
                </span>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SectionLoc;
